import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles<Theme>((theme) => ({
  Dialog: {
    margin: '0rem',
    '& ::-webkit-scrollbar': {
      display: 'none',
    },
    '& >div': {},
    '& >div >div': {
      borderRadius: '35px',
      position: 'absolute',
      maxWidth: 900,
      [theme.breakpoints.down(1070)]: {
        maxWidth: '85%',
      },
      [theme.breakpoints.down(900)]: {
        margin: '0 0 0 0',
        maxWidth: '100%',
        height: '100rem',
      },
    },
    '& >div >div >div': {
      borderRadius: '35px',
    },
  },
  container: {
    width: '42.5rem',
    display: 'flex',
    flexDirection: 'column',
    background: '#212121',
    paddingTop: '9rem',
    color: '#FFFFFF',
    gap: '1rem',
    [theme.breakpoints.down(1240)]: {
      width: '100%',
      height: '100%',
    },
    [theme.breakpoints.down(1070)]: {
      paddingTop: '5rem',
    },
    '& p': {},
  },
  container2: {
    borderRadius: '35px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    background: '#FFFFFF',
    height: '42rem',
    gap: '1rem',
    color: '#7d7c7c',
    padding: '2.5rem',
    [theme.breakpoints.down(1240)]: {
      width: '100%',
      height: '100%',
    },
    '& p': {},
  },
  pointer: {
    cursor: 'pointer',
  },
  titleText: {
    fontSize: '1.5rem',
    fontFamily: 'Montserrat',
    fontWeight: 'bold',
    color: '#212121',
    [theme.breakpoints.down(1240)]: {
      fontSize: '1rem',
    },
  },
  infoText: {
    fontSize: '0.75rem',
    fontFamily: 'Nunito',
    fontWeight: 'normal',
    color: '#7d7c7c',
  },
  hidden: {
    display: 'none',
  },
  bottomBackButtonContainer: {
    borderRadius: '11px',
    height: '2.5rem',
    background: '#212121a6',
    display: 'flex',
    alignItems: 'center',
    '& p': {
      cursor: 'pointer',
    },
  },
  image: {
    width: '43rem',
    maxWidth: 'none',
    [theme.breakpoints.down(1240)]: {
      width: '57rem',
    },
    [theme.breakpoints.down(990)]: {
      width: '100%',
    },
  },
  iconback: {
    cursor: 'pointer',
    position: 'absolute',
  },
  closeButtonContainer: {
    width: '2.5rem',
    height: '2.5rem',
    background: '#212121a6',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '15px',
    position: 'absolute',
    margin: '0 0 10rem 1.5rem',
    [theme.breakpoints.down(1240)]: {
      margin: '0 0 4rem 1rem',
    },
  },
  descuentoConteiner: {
    padding: '1rem 5.5rem',
    gap: '2rem',
    display: 'grid',
    [theme.breakpoints.down(800)]: {
      padding: '1rem 0rem',
    },
  },
  pasosContainer: {
    display: 'grid',
    gap: '0.75rem',
    padding: '0rem 1.5rem',
  },
  pasosText2: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontFamily: 'Montserrat',
    [theme.breakpoints.down(500)]: {
      fontSize: '0.75rem',
    },
  },
  pasosText: {},
  paso: {
    display: 'flex',
    gap: '0.5rem',
    fontSize: '0.75rem',
  },
  icon: {},
  descuento: {
    border: '2px dashed #00323C',
    borderRadius: '16px',
    padding: '1rem',
  },
  descuentoText: {
    fonrSize: '0.75rem',
    textTransform: 'uppercase',
    fontFamily: 'Montserrat',
  },
  descuentoText2: {
    color: '#0a5a64',
    fontSize: '2rem',
    fontWeight: 'bold',
    fontFamily: 'Montserrat',
  },
  descuentoText3: {
    fontSize: '0.75rem',
    marginBottom: '1rem',
  },
  descuentoText4: {
    color: '#646464',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    marginBottom: '2rem',
    display: 'flex',
    justifyContent: 'center',
  },
  canjear: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '0.5rem',
    cursor: 'pointer',
  },
  canjearText: {},
}));
export default useStyles;
